import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=04451ba4&scoped=true&"
import script from "./DetailCard.vue?vue&type=script&lang=js&"
export * from "./DetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=04451ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04451ba4",
  null
  
)

export default component.exports